// Do not import this file directly!
// This is meant as a template for a one-time configuration for a given platform
// Instead, create a file configuring dataSource (like src/services/dataSource)
// and import from there.

import {dataSource as _ds, addDataSource as _ads} from './dataSource'
import {allMap, ALL} from '../../Data/typeDirs'
// import {dbxProps} from './genericDbx'
import {fsProps} from './genericFs'
import {memProps} from './genericMem'
import {remDbProps, remDbInit} from './genericRemDb'
// console.log('allMap', allMap)

const dataSource = _ds
const addDataSource = _ads
const typeDirs = {...allMap, ALL, allMap}
// const genericDbx = dbxProps
const genericFs = fsProps
const genericRemDb = remDbProps
const genericMem = memProps
const initRemDb = remDbInit

export {
  addDataSource,
  dataSource,
  typeDirs,
  // genericDbx,
  genericFs,
  genericRemDb,
  genericMem,
  initRemDb
}
